import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';

import { IFsLprCameraUpdateInterface } from '../interfaces/lpr-camera.interface';
import { LprCameraModel } from '../models/lpr-camera.model';

@Injectable({ providedIn: 'root' })
export class FsLprCamerasService {
  private _api: string;
  constructor(private readonly _httpClient: HttpClient) {
    this._api = localStorage.getItem('LPR_API') ?? '';
  }

  public getCameraList(
    params?: ISnListQueryParameters,
  ): Observable<ISnListResponse<LprCameraModel>> {
    if (!this._api) {
      console.warn('LPR API is disabled or not configured');
      return of({
        random: [],
        count: 0,
        totalPages: 0,
        results: [],
      });
    }
    return this._httpClient.get(`${this._api}/api/cameras/`, { params }).pipe(
      map((response: any) => ({
        random: response.properties,
        count: response.total,
        totalPages: response.pages,
        results: response.items.map((camera) => new LprCameraModel(camera)),
      })),
    );
  }

  public getCameraMap(params?: any): Observable<any> {
    if (!this._api) {
      console.warn('LPR API is disabled or not configured');
      return of({
        type: 'FeatureCollection',
        features: [],
      });
    }
    return this._httpClient.get(`${this._api}/api/cameras/map/`, { params }).pipe(
      map((response: any) =>
        response.features.map((camera) => {
          return {
            properties: camera.properties,
            geometry: camera.geometry,
          };
        }),
      ),
    );
  }

  public updateCameras(
    provider: string,
    cameraId: string,
    data: IFsLprCameraUpdateInterface,
  ): Observable<any> {
    if (!this._api) {
      console.warn('LPR API is disabled or not configured');
      return of([]);
    }
    return this._httpClient.patch(
      `${this._api}/api/cameras/${provider.replace(/\s+/g, '_').toUpperCase()}/${cameraId}/`,
      data,
    );
  }

  public getProviders(params?: ISnListQueryParameters): Observable<any> {
    if (!this._api) {
      console.warn('LPR API is disabled or not configured');
      return of([]);
    }
    return this._httpClient.get(`${this._api}/api/providers/`, { params });
  }
}
